import React, { FC } from 'react';
import styles from './menuWrapper.module.scss';

const MenuWrapper: FC = props => (
    <div className={styles.menuWrapper}>
        {props.children}
    </div>
)
export default MenuWrapper;
